export const pagesPaths = {
  home: '/home',
  proxy: '/proxy'
} as const;

export type PagesPathsKeys = keyof typeof pagesPaths;
